export const GET_NURSERY_STRIPE_INTEGRATION = 'GET_NURSERY_STRIPE_INTEGRATION'
export const GET_NURSERY_STRIPE_INTEGRATION_FAILED = 'GET_NURSERY_STRIPE_INTEGRATION_FAILED'
export const GET_NURSERY_STRIPE_INTEGRATION_SUCCESS = 'GET_NURSERY_STRIPE_INTEGRATION_SUCCESS'
